import { FC, useState } from 'react';
import { Button, Divider, Icon } from 'common-components';
import ActionsMenuProps from './actionsMenuTypes';
import styles from './actionsMenu.module.scss';
import { useTranslationContext } from '../../../contexts/translationContext';

const ActionsMenu: FC<ActionsMenuProps> = (props: ActionsMenuProps) => {
    const { onEdit, onDelete } = props;

    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const { translate } = useTranslationContext();

    const EDIT = translate('Edit');
    const DELETE = translate('Delete');
    const CANCEL = translate('Cancel');
    const APPROVE = translate('Approve');

    return (
        <div className={styles.container} onClick={(_event: any) => _event.stopPropagation()}>
            <div style={{ width: '100%' }}>
                <Button
                    type={'learningPanelAdminActionMenuButton'}
                    text={EDIT}
                    onClick={() => onEdit()}
                    lowerCase={true}
                    className={styles['container-button']}
                    startIcon={<Icon name={'editAdmin'} style={{ display: 'flex', width: '1.4rem' }} />}
                />
            </div>
            {!isDeleting ? (
                <div style={{ width: '100%' }}>
                    <Button
                        type={'learningPanelAdminActionMenuButton'}
                        text={DELETE}
                        onClick={() => setIsDeleting(true)}
                        lowerCase={true}
                        className={styles['container-button']}
                        startIcon={<Icon name={'deleteEvent'} style={{ display: 'flex', width: '1.2rem' }} />}
                    />
                </div>
            ) : (
                <div className={styles['delete-container']}>
                    <div className={styles['delete-header']}>
                        <Icon name={'trashPink'} style={{ display: 'flex', width: '1.4rem' }} />
                        <span>{DELETE}?</span>
                    </div>
                    <Divider orientation="horizontal" color="rgba(98, 98, 98, 0.30)" />
                    <div className={styles['actions-container']}>
                        <Button
                            type={'learningPanelAdminCredentialCardAction'}
                            text={CANCEL}
                            onClick={() => setIsDeleting(false)}
                            lowerCase={true}
                            className={styles['action-button']}
                        />
                        <Button
                            type={'learningPanelAdminCredentialCardAction'}
                            text={APPROVE}
                            onClick={() => onDelete()}
                            lowerCase={true}
                            className={styles['action-button']}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionsMenu;
